<div class="main-container">
  <div>
    <div class="page-header">
      <div class="routing-buttons">
        <!-- (click)="navigateBack()" -->
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">OTA Batch</span>
      </div>

      @if (createOta) {
        <div class="button-group">
          <button class="primary-button" (click)="navigateTo('/ota-master')">
            OTA Master <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
          <button
            class="primary-button"
            [disabled]="!createOta"
            (click)="navigateTo('/ota-batch-create')"
          >
            Create New Batch <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
          <button
            type="button"
            class="primary-button"
            [disabled]="!createOta"
            (click)="openManualOtaPage()"
          >
            Manual OTA <mat-icon class="btn-icon">open_in_new</mat-icon>
          </button>
        </div>
      }
    </div>

    @if (viewOta) {
      <div class="component-container">
        <!-- Component Header Section -->
        <div class="component-header">
          <h6 class="component-title">OTA Batch List</h6>
          <div class="component-actions">
            <app-common-search
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <table>
            <thead>
              <tr>
                <th>Batch ID</th>
                <th>Batch Name</th>
                <th>Created By</th>
                <th>Created At</th>
                <th>Batch Breakdown</th>
                <th>Completed Percentage</th>
                <th>Batch Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              @for (devicevalue of listOfBatch; track devicevalue) {
                <tr>
                  <td>{{ devicevalue.id }}</td>
                  <td>{{ devicevalue.name }}</td>
                  <td>{{ devicevalue.createdBy }}</td>
                  <td>
                    {{
                      devicevalue.createAt | date: 'dd MMM yyyy | hh:mm:ss a'
                    }}
                  </td>
                  <td>
                    C-{{ devicevalue.completeDeviceCount }} | A-{{
                      devicevalue.abortedDeviceCount
                    }}
                    | IP-{{ devicevalue.inprogressDeviceCount }} | T-{{
                      devicevalue.submittedDeviceCount
                    }}
                  </td>
                  <td>{{ devicevalue.completedPercentage }} %</td>
                  <td>
                    <i
                      class="fa fa-circle"
                      [ngClass]="{
                        green: devicevalue.batchStatus === 'Completed',
                        yellow: devicevalue.batchStatus === 'In progress',
                        red: devicevalue.batchStatus === 'Aborted',
                      }"
                      aria-hidden="true"
                    ></i>
                    {{ devicevalue.batchStatus }}
                  </td>
                  <td>
                    <div class="action-buttons">
                      <button
                        class="primary-button view-button"
                        (click)="showBatchDetails('true', devicevalue)"
                      >
                        <mat-icon class="btn-icon">visibility</mat-icon>
                      </button>
                      @if (deleteOta) {
                        <button
                          type="button"
                          class="primary-button abort-button"
                          (click)="abortOtaBatch(devicevalue.id)"
                          [disabled]="devicevalue.inprogressDeviceCount === 0"
                        >
                          <mat-icon class="btn-icon">block</mat-icon>
                        </button>
                      }
                      <button
                        class="primary-button export-button"
                        (click)="downloadBatchDetails(devicevalue.id)"
                      >
                        <mat-icon class="btn-icon">file_download</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
            @if (listOfBatch.length < 1) {
              <tbody>
                <tr>
                  <td colspan="12">
                    <img
                      loading="lazy"
                      class="no-data-img"
                      src="../../assets/dataNotFound.jpg"
                      alt="No Data Found"
                    />
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
        <div class="component-separator"></div>
        @if (listOfBatch.length > 0) {
          <div class="component-footer">
            <app-common-component-pagination
              [totalItems]="totalItems"
              [pageSize]="pageSize"
              [currentPage]="currentPage"
              (pageChange)="onPageChange($event)"
              (sizeChange)="onSizeChange($event)"
            >
            </app-common-component-pagination>
          </div>
        }
      </div>
    }
  </div>
</div>
